import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import './Menu.css';
import logo from './logo.png';

class Menu extends Component {
    constructor(props) {
        super(props);
        this.state = {menuOn: false, right: '-100%'};
        this.clsStyle = {};
    }
    toggleMobileMenu = () => {
        if(this.state.menuOn) {
            this.clsStyle = {right: '-110%', opacity: '0', transform: 'scale(0.8)'};
        } else {
            this.clsStyle = {right: '0%', opacity: '1', transform: 'scale(1)'};
        }
        this.setState(state => ({menuOn: !state.menuOn}));
    }
    render() {
        return (
            <div className="nav">
                <div className="rel">
                    <NavLink className="logo" to="/" exact><img src={logo} /></NavLink>
                    <a onClick={this.toggleMobileMenu} className="btnOp">Menu</a>
                    <ul style={this.clsStyle}>
                        <li><NavLink to="/" exact>Strona Główna</NavLink></li>
                        <li><NavLink to="/o-nas">O Nas</NavLink></li>
                        <li><NavLink to="/kontakt">Kontakt</NavLink></li>
                        <li><NavLink to="/pokoje">Pokoje</NavLink></li>
                        <li><NavLink to="/restauracja">Restauracja Stara Wozownia</NavLink></li>
                        <li><NavLink to="/okolica">okolica</NavLink></li>
                        <li className="btn-cls"><a onClick={this.toggleMobileMenu}>Zamknij >></a></li>
                    </ul>
                </div>
            </div>
        );
}
}

export default Menu;


// WEBPACK FOOTER //
// ./src/Menu/Menu.js